import { render, staticRenderFns } from "./mobileStudio.vue?vue&type=template&id=67271ed1&scoped=true"
import script from "./mobileStudio.vue?vue&type=script&lang=js"
export * from "./mobileStudio.vue?vue&type=script&lang=js"
import style0 from "./mobileStudio.vue?vue&type=style&index=0&id=67271ed1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67271ed1",
  null
  
)

export default component.exports